// extracted by mini-css-extract-plugin
module.exports = {"cc-side-effect-consult":"_2je8d","cc-side-effect-consult-wrap":"_1k06X"};